export const ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE = 'adminHeaderAndFooterConfig';
export const ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME = '/admin/header-and-footer';
